import _ from 'lodash'

export default {
    state: {
        operator: null,
        organizations: null,
        activeOrganizationId: null,
        subscriptions: null,
        defaultPlatformId: null,

        hasSubscription: false,
        isDevModeEnabled: false,
        isSfStaffDisabled: false,
    },

    /* eslint-disable no-param-reassign */
    mutations: {
        'self:operator': function (state, { operator }) {
            state.operator = operator
        },
        'self:organizations': function (state, { organizations }) {
            state.organizations = _.orderBy(organizations, ['name'], ['asc'])
        },
        'self:activeOrganizationId': function (state, { id }) {
            state.activeOrganizationId = id
        },
        'self:clear': function (state) {
            if (this.$posthog) {
                this.$posthog.reset()
            }

            state.operator = null
            state.organizations = null
            state.activeOrganizationId = null
            state.subscriptionTier = null,
            state.discoveryInstagramAudienceFilters = false
        },
        'self:toggleDevMode': function (state) {
            state.isDevModeEnabled = !state.isDevModeEnabled
        },
        'self:toggleStaffMode': function (state) {
            state.isSfStaffDisabled = !state.isSfStaffDisabled
        },
        'self:subscriptionTier': function (state, { subscriptionTier }) {
            state.subscriptionTier = subscriptionTier
        },
        'self:discoveryInstagramAudienceFilters': function (state, { discoveryInstagramAudienceFilters }) {
            state.discoveryInstagramAudienceFilters = discoveryInstagramAudienceFilters
        },
        'self:defaultPlatformId': function (state, { defaultPlatformId }) {
            state.defaultPlatformId = defaultPlatformId
        },
        'self:hasSubscription': function (state, { hasSubscription }) {
            state.hasSubscription = hasSubscription
        },
        /* eslint-enable no-param-reassign */
    },

    getters: {
        self(state) {
            return state
        },

        selfOperator(state) {
            return state.operator
        },

        selfOrganizations(state) {
            return state.organizations
        },

        selfActiveOrganizationId(state) {
            return state.activeOrganizationId
        },

        selfActiveOrganization(state) {
            return _.find(state.organizations, (item) => item.id === state.activeOrganizationId)
        },

        isLegacyBilling(state) {
            const activeOrg = _.find(state.organizations, (item) => item.id === state.activeOrganizationId)
            return activeOrg?.is_legacy_billing === true
        },

        isSfStaff(state) {
            return (
                state.isSfStaffDisabled === false &&
                !!_.find(state.organizations, (organization) => organization.type === 'admin')
            )

            // const activeOrganization = _.find(state.organizations, (item) => item.id === state.activeOrganizationId)
            // return activeOrganization && activeOrganization.type === 'admin'
        },

        isSfStaffDefinitive(state) {
            return !!_.find(state.organizations, (organization) => organization.type === 'admin')
        },

        isDevModeEnabled(state) {
            return state.isDevModeEnabled
        },

        isSfStaffDisabled(state) {
            return state.isSfStaffDisabled
        },

        selfSubscriptionTier(state) {
            return state.subscriptionTier
        },

        selfdDiscoveryInstagramAudienceFiltersEnabled(state) {
            return state.discoveryInstagramAudienceFilters
        },

        selfDefaultPlatformId(state) {
            return state.defaultPlatformId
        },

        selfHasSubscription(state) {
            return state.hasSubscription
        },
    },
}
